var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnClosePopup = function SvgBtnClosePopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z",
    fill: "#000",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.894 26.879a.75.75 0 0 0 0-1.061l-5.833-5.834 5.833-5.833.067-.077a.75.75 0 0 0-1.127-.984L20 18.924l-5.834-5.834-.076-.067a.75.75 0 0 0-.984 1.128l5.833 5.833-5.833 5.834-.067.077a.75.75 0 0 0 1.127.984L20 21.045l5.834 5.834.076.067a.75.75 0 0 0 .984-.067Z",
    fill: "#fff"
  })));
};
export default SvgBtnClosePopup;